import { addElements } from 'state/utils/array';
import { isExternalQuoteId, isPricerId, isQuoteId, isProductId } from 'utils/string';

export function verifyQuoteImportIdentifiers(
  identifiers: readonly string[],
): Record<'valid' | 'invalid', readonly string[]> {
  return identifiers.reduce(
    (acc, id) => {
      const isValidQuoteId = isQuoteId(id);
      const isValidExternalQuoteId = isExternalQuoteId(id);
      const isValidPricerQuoteId = isPricerId(id);
      const isValidProductId = isProductId(id);
      return isValidQuoteId || isValidExternalQuoteId || isValidPricerQuoteId || isValidProductId
        ? { ...acc, valid: addElements(acc.valid, id) }
        : { ...acc, invalid: addElements(acc.invalid, id) };
    },
    {
      valid: [] as readonly string[],
      invalid: [] as readonly string[],
    },
  );
}
